import { produce } from 'immer';

import { RESET_STATE } from 'store/global/actions';
import { LENDERS_MAPPINGS_ACTION_TYPE } from 'store/system/actions';

const initialState = {
  optimalBlueInvestors: [],
  loanSifterInvestors: [],
  companyMappings: [],
  userMappings: [],
};

const lendersMappingsReducer = (state = initialState, { type, payload }) =>
  produce(state, () => {
    switch (type) {
      case LENDERS_MAPPINGS_ACTION_TYPE.GET_OPTIMAL_BLUE_INVESTORS:
        return {
          ...state,
          optimalBlueInvestors: payload || initialState.optimalBlueInvestors,
        };

      case LENDERS_MAPPINGS_ACTION_TYPE.GET_LOAN_SIFTER_INVESTORS:
        return {
          ...state,
          loanSifterInvestors: payload || initialState.loanSifterInvestors,
        };

      case LENDERS_MAPPINGS_ACTION_TYPE.GET_LENDERS_MAPPINGS:
        return {
          ...state,
          companyMappings: payload.companyMappings || initialState.companyMappings,
          userMappings: payload.userMappings || initialState.userMappings,
        };

      case LENDERS_MAPPINGS_ACTION_TYPE.EDIT_LENDERS_MAPPINGS:
        return {
          ...state,
          companyMappings: payload.companyMappings || initialState.companyMappings,
          userMappings: payload.userMappings || initialState.userMappings,
        };

      case RESET_STATE:
        return initialState;

      default:
        return state;
    }
  });

export default lendersMappingsReducer;
